__turbopack_context__.v({
  "action": "styles-module__Rkn9rG__action",
  "detail": "styles-module__Rkn9rG__detail",
  "headRow": "styles-module__Rkn9rG__headRow",
  "name": "styles-module__Rkn9rG__name",
  "row": "styles-module__Rkn9rG__row",
  "summary": "styles-module__Rkn9rG__summary",
  "table": "styles-module__Rkn9rG__table",
  "thumb": "styles-module__Rkn9rG__thumb",
  "unit": "styles-module__Rkn9rG__unit",
});
